export default (api, resource) => ({

    getAll: async ({ token }) => {
        const response = await api.get(`/${resource}`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    getById: async ({ id, token }) => {
        const response = await api.get(`/${resource}/${id}`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    create: async ({ configuracao, token }) => {
        const response = await api.post(`/${resource}`, configuracao, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    // O token de pagamento nunca volta na leitura. Se o campo vier vazio aqui,
    // o backend mantem o token atual -- ver UpdatePaymentSettingRequestHttpDTO.
    update: async ({ id, configuracao, token }) => {
        const response = await api.put(`/${resource}/${id}`, configuracao, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    remove: async ({ id, token }) => {
        const response = await api.delete(`/${resource}/${id}`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    }
})
